module.exports = __webpack_public_path__ + "static/how-not-to-be-wrong-cc606a03159d119c760d0c3e65c72f4d.jpg";